import React from 'react';
import SavedItemCard from '@gik/user-profile/components/SavedItemCard/SavedItemCard';
import WordpressArticle from '@gik/core/models/wordpress/WordpressArticle';

export interface ISavedArticleCard {
  article: WordpressArticle;
  onRemove?(article: WordpressArticle): Promise<void>;
}

export default function SavedArticleCard({ article, onRemove }: ISavedArticleCard) {
  return (
    <SavedItemCard
      item={{
        name: 'article',
        title: article.title.rendered,
        link: `/articles/${article.slug}`,
        thumbnail: article.acf.thumb.sizes.thumbnail,
        removeItem: () => onRemove(article),
      }}
    />
  );
}
